import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type QuickSearchAssetMatchFields_AssigneeMatch_Fragment = { __typename?: 'AssigneeMatch', assignee?: { __typename?: 'AuthenticatedUser', name?: string | null, avatarColor?: Types.AvatarColor | null, profileImage?: { __typename?: 'Images', image64?: string | null } | null } | null };

export type QuickSearchAssetMatchFields_AudioSampleRateMatch_Fragment = { __typename?: 'AudioSampleRateMatch', audioSampleRate?: number | null };

export type QuickSearchAssetMatchFields_BitDepthMatch_Fragment = { __typename?: 'BitDepthMatch', bitDepth?: number | null };

export type QuickSearchAssetMatchFields_BitRateMatch_Fragment = { __typename?: 'BitRateMatch', bitRate?: number | null };

export type QuickSearchAssetMatchFields_ChannelsMatch_Fragment = { __typename?: 'ChannelsMatch', channels?: number | null };

export type QuickSearchAssetMatchFields_CodecMatch_Fragment = { __typename?: 'CodecMatch', codec?: string | null };

export type QuickSearchAssetMatchFields_ColorSpaceMatch_Fragment = { __typename?: 'ColorSpaceMatch', colorSpace?: string | null };

export type QuickSearchAssetMatchFields_CommentCountMatch_Fragment = { __typename?: 'CommentCountMatch', commentCount?: number | null };

export type QuickSearchAssetMatchFields_CommentMatch_Fragment = { __typename?: 'CommentMatch', snippet?: string | null, terms?: Array<string | null> | null, comment?: { __typename?: 'Comment', id: string, text?: string | null, insertedAt?: string | null, owner?: { __typename?: 'AuthenticatedUser', id: string, name?: string | null, avatarColor?: Types.AvatarColor | null, profileImage?: { __typename?: 'Images', image64?: string | null } | null } | { __typename?: 'IdentifiedUser', id: string, name?: string | null, avatarColor?: Types.AvatarColor | null } | null } | null };

export type QuickSearchAssetMatchFields_CreatorMatch_Fragment = { __typename?: 'CreatorMatch', creator?: { __typename?: 'AuthenticatedUser', name?: string | null, avatarColor?: Types.AvatarColor | null, profileImage?: { __typename?: 'Images', image64?: string | null } | null } | null };

export type QuickSearchAssetMatchFields_DeletedAtMatch_Fragment = { __typename?: 'DeletedAtMatch', deletedAt?: string | null };

export type QuickSearchAssetMatchFields_DurationMatch_Fragment = { __typename?: 'DurationMatch', duration?: number | null };

export type QuickSearchAssetMatchFields_DynamicRangeMatch_Fragment = { __typename?: 'DynamicRangeMatch', dynamicRange?: string | null };

export type QuickSearchAssetMatchFields_FileTypeMatch_Fragment = { __typename?: 'FileTypeMatch', fileType?: string | null };

export type QuickSearchAssetMatchFields_FilesizeMatch_Fragment = { __typename?: 'FilesizeMatch', filesize?: number | null };

export type QuickSearchAssetMatchFields_FormatMatch_Fragment = { __typename?: 'FormatMatch', format?: string | null };

export type QuickSearchAssetMatchFields_FrameRateMatch_Fragment = { __typename?: 'FrameRateMatch', frameRate?: number | null };

export type QuickSearchAssetMatchFields_HasAlphaChannelMatch_Fragment = { __typename?: 'HasAlphaChannelMatch', hasAlphaChannel?: boolean | null };

export type QuickSearchAssetMatchFields_InsertedAtMatch_Fragment = { __typename?: 'InsertedAtMatch', insertedAt?: string | null };

export type QuickSearchAssetMatchFields_KeywordsMatch_Fragment = { __typename?: 'KeywordsMatch', keywords?: Array<{ __typename?: 'SelectOption', color?: string | null, displayName: string, id: string } | null> | null };

export type QuickSearchAssetMatchFields_NameMatch_Fragment = { __typename?: 'NameMatch', name?: string | null, terms?: Array<string | null> | null };

export type QuickSearchAssetMatchFields_NotesMatch_Fragment = { __typename?: 'NotesMatch', notes?: string | null };

export type QuickSearchAssetMatchFields_PageCountMatch_Fragment = { __typename?: 'PageCountMatch', pageCount?: number | null };

export type QuickSearchAssetMatchFields_ProjectMatch_Fragment = { __typename?: 'ProjectMatch' };

export type QuickSearchAssetMatchFields_RatingMatch_Fragment = { __typename?: 'RatingMatch', rating?: number | null, color?: string | null, style?: Types.RatingStyleEnum | null };

export type QuickSearchAssetMatchFields_ResolutionHeightMatch_Fragment = { __typename?: 'ResolutionHeightMatch', resolutionHeight?: number | null };

export type QuickSearchAssetMatchFields_ResolutionWidthMatch_Fragment = { __typename?: 'ResolutionWidthMatch', resolutionWidth?: number | null };

export type QuickSearchAssetMatchFields_SourceFilenameMatch_Fragment = { __typename?: 'SourceFilenameMatch', sourceFilename?: string | null, terms?: Array<string | null> | null };

export type QuickSearchAssetMatchFields_StatusMatch_Fragment = { __typename?: 'StatusMatch', status?: { __typename?: 'SelectOption', color?: string | null, displayName: string, id: string } | null };

export type QuickSearchAssetMatchFields_TranscriptionMatch_Fragment = { __typename?: 'TranscriptionMatch', matches?: { __typename?: 'TranscriptionResultMatchConnection', nodes: Array<{ __typename?: 'TranscriptionResultMatch', id?: string | null, snippets?: Array<string | null> | null, terms?: Array<string | null> | null }> } | null };

export type QuickSearchAssetMatchFields_UpdatedAtMatch_Fragment = { __typename?: 'UpdatedAtMatch', updatedAt?: string | null };

export type QuickSearchAssetMatchFields_UploadedAtMatch_Fragment = { __typename?: 'UploadedAtMatch', uploadedAt?: string | null };

export type QuickSearchAssetMatchFields_VisualMatch_Fragment = { __typename?: 'VisualMatch', clips?: Array<{ __typename?: 'VisualResultMatch', bestFrameTime?: number | null, startTime?: number | null, endTime?: number | null, index?: number | null, relevancyIndex?: number | null } | null> | null };

export type QuickSearchAssetMatchFieldsFragment = QuickSearchAssetMatchFields_AssigneeMatch_Fragment | QuickSearchAssetMatchFields_AudioSampleRateMatch_Fragment | QuickSearchAssetMatchFields_BitDepthMatch_Fragment | QuickSearchAssetMatchFields_BitRateMatch_Fragment | QuickSearchAssetMatchFields_ChannelsMatch_Fragment | QuickSearchAssetMatchFields_CodecMatch_Fragment | QuickSearchAssetMatchFields_ColorSpaceMatch_Fragment | QuickSearchAssetMatchFields_CommentCountMatch_Fragment | QuickSearchAssetMatchFields_CommentMatch_Fragment | QuickSearchAssetMatchFields_CreatorMatch_Fragment | QuickSearchAssetMatchFields_DeletedAtMatch_Fragment | QuickSearchAssetMatchFields_DurationMatch_Fragment | QuickSearchAssetMatchFields_DynamicRangeMatch_Fragment | QuickSearchAssetMatchFields_FileTypeMatch_Fragment | QuickSearchAssetMatchFields_FilesizeMatch_Fragment | QuickSearchAssetMatchFields_FormatMatch_Fragment | QuickSearchAssetMatchFields_FrameRateMatch_Fragment | QuickSearchAssetMatchFields_HasAlphaChannelMatch_Fragment | QuickSearchAssetMatchFields_InsertedAtMatch_Fragment | QuickSearchAssetMatchFields_KeywordsMatch_Fragment | QuickSearchAssetMatchFields_NameMatch_Fragment | QuickSearchAssetMatchFields_NotesMatch_Fragment | QuickSearchAssetMatchFields_PageCountMatch_Fragment | QuickSearchAssetMatchFields_ProjectMatch_Fragment | QuickSearchAssetMatchFields_RatingMatch_Fragment | QuickSearchAssetMatchFields_ResolutionHeightMatch_Fragment | QuickSearchAssetMatchFields_ResolutionWidthMatch_Fragment | QuickSearchAssetMatchFields_SourceFilenameMatch_Fragment | QuickSearchAssetMatchFields_StatusMatch_Fragment | QuickSearchAssetMatchFields_TranscriptionMatch_Fragment | QuickSearchAssetMatchFields_UpdatedAtMatch_Fragment | QuickSearchAssetMatchFields_UploadedAtMatch_Fragment | QuickSearchAssetMatchFields_VisualMatch_Fragment;

export const QuickSearchAssetMatchFields = /*#__PURE__*/ gql`
    fragment QuickSearchAssetMatchFields on AssetResultMatch {
  ... on AssigneeMatch {
    assignee {
      name
      avatarColor
      profileImage {
        image64
      }
    }
  }
  ... on NameMatch {
    name
    terms
  }
  ... on CreatorMatch {
    creator {
      name
      avatarColor
      profileImage {
        image64
      }
    }
  }
  ... on FormatMatch {
    format
  }
  ... on SourceFilenameMatch {
    sourceFilename
    terms
  }
  ... on KeywordsMatch {
    keywords {
      color
      displayName
      id
    }
  }
  ... on StatusMatch {
    status {
      color
      displayName
      id
    }
  }
  ... on RatingMatch {
    rating
    color
    style
  }
  ... on CommentCountMatch {
    commentCount
  }
  ... on PageCountMatch {
    pageCount
  }
  ... on DurationMatch {
    duration
  }
  ... on FilesizeMatch {
    filesize
  }
  ... on AudioSampleRateMatch {
    audioSampleRate
  }
  ... on TranscriptionMatch {
    matches(page: {first: 1}) {
      nodes {
        id
        snippets
        terms
      }
    }
  }
  ... on VisualMatch {
    clips {
      bestFrameTime
      startTime
      endTime
      index
      relevancyIndex
    }
  }
  ... on CommentMatch {
    comment {
      id
      text
      owner {
        id
        name
        avatarColor
        ... on AuthenticatedUser {
          profileImage {
            image64
          }
        }
      }
      insertedAt
    }
    snippet
    terms
  }
  ... on NotesMatch {
    notes
  }
  ... on InsertedAtMatch {
    insertedAt
  }
  ... on DeletedAtMatch {
    deletedAt
  }
  ... on UpdatedAtMatch {
    updatedAt
  }
  ... on UploadedAtMatch {
    uploadedAt
  }
  ... on FileTypeMatch {
    fileType
  }
  ... on BitDepthMatch {
    bitDepth
  }
  ... on BitRateMatch {
    bitRate
  }
  ... on CodecMatch {
    codec
  }
  ... on ChannelsMatch {
    channels
  }
  ... on FrameRateMatch {
    frameRate
  }
  ... on HasAlphaChannelMatch {
    hasAlphaChannel
  }
  ... on ColorSpaceMatch {
    colorSpace
  }
  ... on ResolutionWidthMatch {
    resolutionWidth
  }
  ... on ResolutionHeightMatch {
    resolutionHeight
  }
  ... on DynamicRangeMatch {
    dynamicRange
  }
}
    ` as unknown as DocumentNode<QuickSearchAssetMatchFieldsFragment, unknown>;

        

        
export const useQuickSearchAssetMatchFieldsFragment = (
  input: string | Omit<UseFragmentOptions<QuickSearchAssetMatchFieldsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetResultMatch' } };
    return input;
  })();

  return useFragment<QuickSearchAssetMatchFieldsFragment>({
    fragment: QuickSearchAssetMatchFields,
    fragmentName: 'QuickSearchAssetMatchFields',
    ...options,
  });
};
  
        